// @ components
import { RAKnowledgeExperienceSteps } from './RAKnowledgeExperienceSteps';
// @ vendors
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// @ actions
import RASuitabilityTestWizardActions from 'actions/RASuitabilityTestWizardActions';
import { actions as formActions } from 'react-redux-form';
import RASuitabilityTest from 'actions/RASuitabilityTest';
import stepsActions from 'actions/stepsActions';
import modalCancelActions from 'actions/modalCancelActions';

export const RAKnowledgeExperienceStepsContainer = connect(
    state => ({
        userProfile: state.userProfile,
        RATestWizard: state.raSuitabilityTestWizard,
        immSuitabilityTest: state.raSuitabilityTest,
        products: state.products,
    }),
    dispatch => ({
        raTestActions: bindActionCreators(RASuitabilityTestWizardActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        raSuitabilityTest: bindActionCreators(RASuitabilityTest, dispatch),
        stepsActions: bindActionCreators(stepsActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
    })
)(RAKnowledgeExperienceSteps);
